import { store } from '@/modules/store';
import {
  deleteUserFromLS,
  getUserFromLS,
  deleteFrontendCookies
} from '@/helpers/userHelper';

export const handleOnPublicPage = (authString, next, to) => {
  if (['LogIn', 'forgotPassword'].includes(to.name) && authString !== '') {
    next({
      path: '/'
    });
    return false;
  }

  next();
  return true;
};

export const handleOnPageRequiresAuth = (user, next, to, from) => {
  if (!user.identity?.token) {
    store.commit('authModule/setLandingPage', {
      referer: to.query?.referer || '',
      path: to.path,
      params: to.params
    });
    deleteUserFromLS();
    deleteFrontendCookies();
    next({
      name: 'LogIn'
    });

    return false;
  }

  //if the user is logged in but he refreshed the page ==> empty user in store
  if (store.state.authModule.user.identity.id === '') {
    //get user from local storage
    store.commit('authModule/logIn', getUserFromLS());
  }
  //Hide address-book when going to home page
  if (to.name === 'Home' && store.state.addressBookModule.display === true) {
    store.commit('addressBookModule/displayAddressBook');
  }

  if (
    to.params?.skipLeaveCartPopup !== true &&
    from.name === 'checkout' &&
    to.name !== 'checkout' &&
    store.state.checkOutModule.cart.items.length > 0
  ) {
    store.commit('checkOutModule/openLeaveCartPopup', next);
    return false;
  }

  next();
  return true;
};

export const setMetaTags = to => {
  const routeWithTags = to.matched
    .slice()
    .reverse()
    .find(r => r?.meta?.metaTags);

  const routeWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r?.meta?.title);

  if (routeWithTitle != null) {
    document.title = routeWithTitle.meta.title;
  } else {
    document.title = 'futalis Vet';
  }

  if (routeWithTags != null) {
    Array.from(
      document.querySelectorAll('[data-vue-router-controlled]')
    ).map(el => el.parentNode.removeChild(el));

    routeWithTags.meta.metaTags
      .map(tagDef => {
        const tag = document.createElement('meta');

        Object.entries(tagDef).forEach(([key, value]) => {
          tag.setAttribute(key, value);
        });
        tag.setAttribute('data-vue-router-controlled', '');
        return tag;
      })
      .forEach(tag => document.head.appendChild(tag));
  }
};
